// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FormValidationUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function execute(msisdn, country) {
  switch (country.TAG | 0) {
    case /* UAE */0 :
        if (/^(?:50|51|52|54|55|56|58|2|3|4|6|7|9)\d{10}$/.test(msisdn)) {
          return {
                  TAG: /* Ok */0,
                  _0: msisdn
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Msisdn"
                };
        }
    case /* India */1 :
        return FormValidationUtils$Catalyst.validateMsisdn(msisdn);
    case /* BD */2 :
        if (/(^(1)[3-9](\d){11})$/.test(msisdn)) {
          return {
                  TAG: /* Ok */0,
                  _0: msisdn
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Msisdn"
                };
        }
    case /* TR */3 :
        if (/(^(5)\d{12})$/.test(msisdn)) {
          return {
                  TAG: /* Ok */0,
                  _0: msisdn
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Invalid Msisdn"
                };
        }
    
  }
}

export {
  execute ,
  
}
/* No side effect */
